import React, {useState, useRef, useCallback, useEffect} from "react";
import {useLocation, useNavigate} from "react-router-dom";
import axios from "axios";
import {ToastContainer, toast} from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import LocationSelect from "./components/LocationSelect";
import GearSelect from "./components/GearSelect";
import TerrainSelect from "./components/TerrainSelect";
import VehicleSelect from "./components/VehicleSelect";
import EventTypeSelect from "./components/EventTypeSelect";
import UserSearchDropdown from "./components/UserSearchDropdown";
import AttendanceTabs from "./components/AttendanceTab";

import GPSCoordinateInput from "./components/GpsCoordinateInput";
import AddressToGPSInput from "./components/AddressToGPSInput";
import CommsSelect from "./components/CommSelect";
import OTGToolbar from "./OTGToolBar";


const EditEvent = () => {
    const {state} = useLocation();
    const navigate = useNavigate();
    const location = useLocation();
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isUploading, setIsUploading] = useState(false);
    const [isUploadingImage, setIsUploadingImage] = useState(false);
    const [isAdmin, setIsAdmin] = useState(false);
    const fileInputRef = useRef(null);
    const imageInputRef = useRef(null);

    const [clearCohost1, setClearCohost1] = useState(false);
    const [clearCohost2, setClearCohost2] = useState(false);

    // Convert event from props to a state variable
    const [event, setEvent] = useState(state?.event || {});

    const [ searchTerm] = useState(location.state?.searchTerm || null);
    const [ filters] = useState(location.state?.filters || null);

    const formatToLocalDateTime = (dateStr) => {
        return dateStr;
    };

    const [formData, setFormData] = useState({
        id                 : event.id || "",
        name               : event.name || "",
        going              : event.going || "",
        waiting            : event.waiting || "",
        summary            : event.summary || "",
        start_time         : event.start_time ? formatToLocalDateTime(event.start_time) : "",
        end_time           : event.end_time ? formatToLocalDateTime(event.end_time) : "",
        location           : event.location || "",
        meetup_location    : event.meetup_location || "",
        terrain            : event.terrain ? event.terrain.split(',') : [],
        recommended_vehicle: event.recommended_vehicle ? event.recommended_vehicle.split(',') : [],
        required_gear      : event.required_gear ? event.required_gear.split(',') : [],
        technical_rating   : event.technical_rating || "",
        max_rigs           : event.max_rigs || "",
        gpx_file_url       : event.gpx_file_url || "",
        imageurl          : event.imageurl || "",
        is_public          : event.is_public || false,
        dogs_permitted     : event.dogs_permitted || false,
        children_permitted : event.children_permitted || false,
        disable_promotion  : event.disable_promotion || false,
        eventtype          : event.eventtype || "",
        cohost1            : event.cohost1 || "",
        cohost2            : event.cohost2 || "",
        cohost1UserName    : event.cohost1UserName || "",
        cohost2UserName    : event.cohost2UserName || "",
        goingList          : event.goingList,
        waitingList        : event.waitingList,
        gpscoordinate      : event.gpscoordinate || null,
        meetaddress        : event.meetaddress || null,
        begin_hour_time    : event.begin_hour_time || "",
        end_hour_time: event.end_hour_time || "",
        comms : event.comms || '',
        channel : event.channel || '',
        specialeventurl : event.specialeventurl || '',
        suspendsubs: event.suspendsubs || false,
        open_for_registration: event.open_for_registration !== undefined ? event.open_for_registration : true,
        hide_dates: event.hide_dates || false

    });

    // Wrap the callback in useCallback to prevent recreation
    const handleVehicleChange = useCallback((vehicles) => {
        setFormData(prev => ({...prev, recommended_vehicle: vehicles}))
    }, []);

    // Also wrap other callbacks
    const handleTerrainChange = useCallback((terrain) => {
        setFormData(prev => ({...prev, terrain}))
    }, []);

    const handleGearChange = useCallback((gear) => {
        setFormData(prev => ({...prev, required_gear: gear}))
    }, []);

    // Fetch admin status on component mount
    useEffect(() => {
        const fetchAdminStatus = async () => {
            try {
                const response = await fetch(`/otgservices/getOTGEvents.php?id=${event.id}`);
                const data = await response.json();
                setIsAdmin(data.isadmin || false);
            } catch (error) {
                console.error('Failed to fetch admin status:', error);
            }
        };

        fetchAdminStatus();
    }, []);


    const handleChange = (e) => {
        const {name, value, type, checked} = e.target;
        setFormData({
            ...formData,
            [name]: type === "checkbox" ? checked : value,
        });
    };


    const handleGPSChange =  ( gps)  => {
        if ( !gps) return;
        setFormData(prev => ({
            ...prev,
            gpscoordinate: gps
        }));

    }


    const handleAddressChange =  ( address, gps)  => {
        if ( !gps) return;
        setFormData(prev => ({
            ...prev,
            gpscoordinate: gps,
            meetaddress: address
        }));
        updateMeetAddressOrGPS(gps, address);
    }

    const updateMeetAddressOrGPS = ( gps, address) => {

        const encodedAddress = encodeURIComponent(address);
        const updateUrl = '/otgservices/updateGPSOrMeetAddress.php?gpscoordinate=' + gps+'&meetaddress=' + encodedAddress + '&eventId=' + event.id;
        fetch(updateUrl)
            .then(response => {
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                return response.json();
            })
            .then(json => {
                if (!json.success) {
                    toast.error("Error Updating GPS/MeetAddress:" + json.error);
                }
                else {
                    toast.success("GPS/Meet Address updated successfully.");
                }

            })
            .catch(error => {
                console.error('Error checking subscription:', error);
                toast.error("Error updating Meet Address Please try again.");
            });
    };

    const handleCoHost1Select = (selectedCoHost) => {
        if (!selectedCoHost) {
            return;
        }

        setFormData(prev => ({
            ...prev,
            cohost1: selectedCoHost.id,
            cohost1UserName: selectedCoHost.name
        }));

        // Set flag to clear the dropdown
        setClearCohost1(true);

        // Reset the flag after a short delay
        setTimeout(() => {
            setClearCohost1(false);
        }, 100);

    }

    const handleCoHost2Select = ( selectedCoHost) => {
        if ( !selectedCoHost) {
            return;
        }
        setFormData(prev => ({
            ...prev,
            cohost2: selectedCoHost.id,
            cohost2UserName: selectedCoHost.name
        }));

        // Set flag to clear the dropdown
        setClearCohost2(true);

        // Reset the flag after a short delay
        setTimeout(() => {
            setClearCohost2(false);
        }, 100);
    }
    const handleAttendeeChange = (userId, sourceList, action, targetList = null) => {
        // Clone the current event object

        const updatedEvent = JSON.parse(JSON.stringify(event));

        // Safety check before operations
        if (!updatedEvent[`${sourceList}List`]) {
            updatedEvent[`${sourceList}List`] = [];
        }

        if (action === 'delete') {
            // Remove from the source list
            updatedEvent[`${sourceList}List`] = updatedEvent[`${sourceList}List`].filter(
                attendee => attendee.user_id !== userId
            );
        } else if (action === 'move' && targetList) {
            // Ensure target list exists
            if (!updatedEvent[`${targetList}List`]) {
                updatedEvent[`${targetList}List`] = [];
            }

            // Find the attendee in source list
            const attendeeIndex = updatedEvent[`${sourceList}List`].findIndex(a => a.user_id === userId);

            if (attendeeIndex !== -1) {
                // Get the attendee
                const attendee = updatedEvent[`${sourceList}List`][attendeeIndex];

                // Remove from source list
                updatedEvent[`${sourceList}List`] = updatedEvent[`${sourceList}List`].filter(
                    attendee => attendee.user_id !== userId
                );

                // Add to target list
                updatedEvent[`${targetList}List`].push(attendee);
            }
        }

        // Update the event state
        setEvent(updatedEvent);
    };

    // Handle file upload
    const handleUpload = async () => {
        // Programmatically click the hidden file input
        fileInputRef.current.click();
    };

    // Handle image upload button click
    const handleImageUpload = async () => {
        // Programmatically click the hidden image input
        imageInputRef.current.click();
    };

    // Process the selected file
    const handleFileSelected = async (e) => {
        const file = e.target.files[0];
        if (!file) return;

        // Create form data for the upload
        const formDataForUpload = new FormData();
        formDataForUpload.append('file', file);

        // Check if we have an event ID
        if (!formData.id) {
            toast.error("Please save the event first before uploading files.");
            return;
        }

        setIsUploading(true);
        try {
            // Upload the file
            const response = await axios.post(`/otgservices/UploadRoute.php?event_id=${formData.id}`, formDataForUpload, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });

            if (response.data.success) {
                toast.success("File uploaded successfully!");

                // Update the gpx_file_url in the form if it's a GPX file
                if (file.name.toLowerCase().endsWith('.gpx')) {
                    setFormData(prev => ({
                        ...prev,
                        gpx_file_url: response.data.download_url
                    }));
                    toast.info("GPX file URL updated in the form.");
                }
            } else {
                toast.error("Failed to upload file: " + (response.data.error || "Unknown error"));
            }
        } catch (error) {
            console.error("Upload error:", error);
            toast.error("Failed to upload file: " + (error.response?.data?.error || error.message || "Unknown error"));
        } finally {
            setIsUploading(false);
        }
    };

    // Process the selected image
    const handleImageSelected = async (e) => {
        const file = e.target.files[0];
        if (!file) return;

        // Check file size (in bytes)
        const MAX_FILE_SIZE =  1 * 1024 * 1024; // 1MB in bytes

        if (file.size > MAX_FILE_SIZE) {
            toast.error(`Image File size (${(file.size / (1024 * 1024)).toFixed(1)}MB) exceeds the maximum allowed size (1MB).`);
            // Reset the file input
            e.target.value = '';
            return;
        }

        // Create form data for the upload
        const formDataForUpload = new FormData();
        formDataForUpload.append('file', file);

        // Check if we have an event ID
        if (!formData.id) {
            toast.error("Please save the event first before uploading images.");
            return;
        }

        setIsUploadingImage(true);
        try {
            // Upload the image
            const response = await axios.post(`/otgservices/UploadImage.php?eventId=${formData.id}`, formDataForUpload, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });

            if (response.data.success) {
                toast.success("Image uploaded successfully!");

                // Update the imageurl in the form if provided in the response
                if (response.data.imageurl) {
                    setFormData(prev => ({
                        ...prev,
                        imageurl: response.data.imageurl
                    }));
                    toast.info("Event image updated.");
                }
            } else {
                toast.error("Failed to upload image: " + (response.data.error || "Unknown error"));
            }
        } catch (error) {
            console.error("Image upload error:", error);
            toast.error("Failed to upload image: " + (error.response?.data?.error || error.message || "Unknown error"));
        } finally {
            setIsUploadingImage(false);
        }
    };

    // Handle file download
    const handleDownload = () => {
        // Check if we have a GPX file URL and event ID
        if (!formData.gpx_file_url || !formData.id) {
            toast.warning("No file available for download or event ID is missing.");
            return;
        }

        // Extract the filename from the URL
        const urlParts = formData.gpx_file_url.split('/');
        const filename = urlParts[urlParts.length - 1];

        // Construct the download URL
        const downloadUrl = `/otgservices/DownloadRoute.php?event_id=${formData.id}&file=${filename}`;

        // Open in a new tab/window
        window.open(downloadUrl, '_blank');
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!formData.name || !formData.start_time || !formData.end_time) {
            toast.error("Name, Start Time, and End Time are required.");
            return;
        }

        // Set submitting state to true to disable the button
        setIsSubmitting(true);
        // Transform arrays to strings for API
        const submitData = {
            ...formData,
            required_gear      : Array.isArray(formData.required_gear)
                ? formData.required_gear.join(",")
                : formData.required_gear,
            recommended_vehicle: Array.isArray(formData.recommended_vehicle)
                ? formData.recommended_vehicle.join(",")
                : formData.recommended_vehicle,
            terrain            : Array.isArray(formData.terrain)
                ? formData.terrain.join(",")
                : formData.terrain
        };

        try {
            const response = await axios.post("/otgservices/editEvent.php", submitData, {
                headers: {"Content-Type": "application/json"},
            });

            if (response.data.status === "success") {
                toast.success("Event updated successfully!");
                const  lroute = '/events/#event-' + event.id;

                setTimeout(() => navigate(lroute,  { state: {
                    action   : 'refresh',
                        timestamp: Date.now(),
                        searchTerm : searchTerm,
                        filters : filters
                }}
                ), 500);
            } else {
                toast.error("Failed to update event: " + (response.data.message || "Unknown error"));
            }
            setIsSubmitting(false);
        } catch (error) {
            toast.error("Failed to update event.");
            setIsSubmitting(false);
        }
    };

    const handleCancel = () => {
        const  lroute = '/events/#event-' + event.id;
        navigate(lroute, {
            state: {
                action   : 'refresh',
                timestamp: Date.now(),
                searchTerm : searchTerm,
                filters : filters
            }
        })
    };

    return (
        <div className="p-6 bg-gray-100 min-h-screen">
            <ToastContainer/>
            <OTGToolbar/>
            <h2 className="text-2xl font-bold mb-4 text-center py-2">Edit Event</h2>
            <form onSubmit={handleSubmit} className="max-w-4xl mx-auto bg-white p-6 rounded shadow">
                <input type="hidden" name="id" value={formData.id}/>

                {/* Hidden file inputs for uploads */}
                <input
                    type="file"
                    ref={fileInputRef}
                    onChange={handleFileSelected}
                    style={{display: 'none'}}
                />
                <input
                    type="file"
                    ref={imageInputRef}
                    onChange={handleImageSelected}
                    accept="image/*"
                    style={{display: 'none'}}
                />

                {/* Two-column layout for larger screens */}
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                    {/* Left Column */}
                    <div className="space-y-4">
                        <div>
                            <label className="block mb-1 text-sm font-bold" htmlFor="name">Event Name</label>
                            <input
                                id="name"
                                name="name"
                                type="text"
                                value={formData.name}
                                onChange={handleChange}
                                readOnly
                                className="w-full p-2 border border-gray-300 rounded"
                                required
                            />
                        </div>

                        <div>
                            <label className="block mb-1 text-sm font-bold" htmlFor="summary">Event Summary</label>
                            <textarea
                                id="summary"
                                name="summary"
                                value={formData.summary}
                                onChange={handleChange}
                                className="w-full p-2 border border-gray-300 rounded h-24"
                            />
                        </div>

                        {!formData.hide_dates && (
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                            <div>
                                <label className="block mb-1 text-sm font-bold" htmlFor="start_time">Start
                                    Date</label>
                                <input
                                    id="start_time"
                                    name="start_time"
                                    type="date"
                                    value={formData.start_time}
                                    onChange={handleChange}
                                    className="w-full p-2 border border-gray-300 rounded"
                                    required
                                />
                            </div>
                            <div>
                                <label className="block mb-1 text-sm font-bold" htmlFor="end_time">End Date</label>
                                <input
                                    id="end_time"
                                    name="end_time"
                                    type="date"
                                    value={formData.end_time}
                                    onChange={handleChange}
                                    className="w-full p-2 border border-gray-300 rounded"
                                    required
                                />
                            </div>
                        </div>
                        )}

                        {!formData.hide_dates && (
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                            <div>
                                <label className="block mb-1 text-sm font-bold" htmlFor="start_time">Start Time</label>
                                <input
                                    id="begin_hour_time"
                                    name="begin_hour_time"
                                    type="text"
                                    value={formData.begin_hour_time}
                                    onChange={handleChange}
                                    className="w-full p-2 border border-gray-300 rounded"
                                    required
                                />
                            </div>
                            <div>
                                <label className="block mb-1 text-sm font-bold" htmlFor="end_time">End Time</label>
                                <input
                                    id="end_hour_time"
                                    name="end_hour_time"
                                    type="text"
                                    value={formData.end_hour_time}
                                    onChange={handleChange}
                                    className="w-full p-2 border border-gray-300 rounded"
                                    required
                                />
                            </div>
                        </div>
                        )}


                        <div className="flex flex-wrap gap-4 p-3 border border-gray-300 rounded">
                            <label className="flex items-center space-x-2">
                                <input
                                    type="checkbox"
                                    name="children_permitted"
                                    checked={formData.children_permitted}
                                    onChange={handleChange}
                                />
                                <span>Children</span>
                            </label>

                            <label className="flex items-center space-x-2">
                                <input
                                    type="checkbox"
                                    name="dogs_permitted"
                                    checked={formData.dogs_permitted}
                                    onChange={handleChange}
                                />
                                <span>Dogs</span>
                            </label>

                            <label className="flex items-center space-x-2">
                                <input
                                    type="checkbox"
                                    name="is_public"
                                    checked={formData.is_public}
                                    onChange={handleChange}
                                />
                                <span>Public</span>
                            </label>

                            {isAdmin && (
                                <label className="flex items-center space-x-2">
                                    <input
                                        type="checkbox"
                                        name="suspendsubs"
                                        checked={formData.suspendsubs}
                                        onChange={handleChange}
                                    />
                                    <span>Suspend Subscriptions</span>
                                </label>
                            )}

                            {isAdmin && (
                                <label className="flex items-center space-x-2">
                                    <input
                                        type="checkbox"
                                        name="open_for_registration"
                                        checked={formData.open_for_registration}
                                        onChange={handleChange}
                                    />
                                    <span>Open for Registration</span>
                                </label>
                            )}

                            {isAdmin && (
                                <label className="flex items-center space-x-2">
                                    <input
                                        type="checkbox"
                                        name="hide_dates"
                                        checked={formData.hide_dates}
                                        onChange={handleChange}
                                    />
                                    <span>Hide Dates and Times</span>
                                </label>
                            )}
                        </div>

                        <div>
                            <div className="flex flex-wrap gap-2">
                                {/* Hidden input */}
                                <input
                                    id="gpx_file_url"
                                    name="gpx_file_url"
                                    type="hidden"
                                    value={formData.gpx_file_url}
                                    onChange={handleChange}
                                />
                                <input
                                    id="imageurl"
                                    name="imageurl"
                                    type="hidden"
                                    value={formData.imageurl}
                                    onChange={handleChange}
                                />

                                {/* Download button */}
                                {formData.gpx_file_url && (
                                    <button
                                        type="button"
                                        onClick={handleDownload}
                                        className="bg-blue-500 text-white text-sm px-2 py-1.5 rounded hover:bg-blue-600 disabled:bg-blue-300 flex items-center"
                                        title="Download GPX file"
                                        disabled={!formData.gpx_file_url || !formData.id}
                                    >
                                        <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-1" fill="none"
                                             viewBox="0 0 24 24" stroke="currentColor">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
                                                  d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"/>
                                        </svg>
                                        <span>Download Route</span>
                                    </button>
                                )}

                                {/* Upload Route button */}
                                <button
                                    type="button"
                                    onClick={handleUpload}
                                    className="bg-green-500 text-white text-sm px-2 py-1.5 rounded hover:bg-green-600 disabled:bg-green-300 flex items-center"
                                    title="Upload new GPX file"
                                    disabled={!formData.id || isUploading}
                                >
                                    {isUploading ? (
                                        <>
                                            <svg className="animate-spin h-4 w-4 mr-1"
                                                 xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                                <circle className="opacity-25" cx="12" cy="12" r="10"
                                                        stroke="currentColor"
                                                        strokeWidth="4"></circle>
                                                <path className="opacity-75" fill="currentColor"
                                                      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                            </svg>
                                            <span>Uploading...</span>
                                        </>
                                    ) : (
                                        <>
                                            <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-1" fill="none"
                                                 viewBox="0 0 24 24" stroke="currentColor">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
                                                      d="M4 16v-1a3 3 0 013-3h10a3 3 0 013 3v1m-4-8l-4-4m0 0L8 8m4-4v12"/>
                                            </svg>
                                            <span>Upload GPX file</span>
                                        </>
                                    )}
                                </button>

                                {/* Upload Image button */}
                                <button
                                    type="button"
                                    onClick={handleImageUpload}
                                    className="bg-purple-500 text-white text-sm px-2 py-1.5 rounded hover:bg-purple-600 disabled:bg-purple-300 flex items-center"
                                    title="Upload event image"
                                    disabled={!formData.id || isUploadingImage}
                                >
                                    {isUploadingImage ? (
                                        <>
                                            <svg className="animate-spin h-4 w-4 mr-1"
                                                 xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                                <circle className="opacity-25" cx="12" cy="12" r="10"
                                                        stroke="currentColor"
                                                        strokeWidth="4"></circle>
                                                <path className="opacity-75" fill="currentColor"
                                                      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                            </svg>
                                            <span>Uploading...</span>
                                        </>
                                    ) : (
                                        <>
                                            <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-1" fill="none"
                                                 viewBox="0 0 24 24" stroke="currentColor">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
                                                      d="M4 16l4-4m0 0l4 4m-4-4v12m6-1h2a2 2 0 002-2V7a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2h2"/>
                                            </svg>
                                            <span>Upload Image</span>
                                        </>
                                    )}
                                </button>
                            </div>
                            {/* Show image preview if available */}
                            {/* Image preview with centered display */}
                            {formData.imageurl && (
                                <div className="mt-4">
                                    <div
                                        className="w-full bg-gray-100 rounded border border-gray-300 overflow-hidden flex justify-center items-center"
                                        style={{minHeight: "200px"}}>
                                        <img
                                            src={formData.imageurl}
                                            alt="Event"
                                            className="max-w-full max-h-96 object-contain"
                                            style={{imageRendering: 'high-quality'}}
                                        />
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>

                    {/* Right Column */}
                    <div className="space-y-4">
                        <EventTypeSelect
                            value={formData.eventtype}
                            onChange={(e) =>
                                setFormData(prev => ({...prev, eventtype: e.target.value}))
                            }
                        />

                        <VehicleSelect
                            selectedVehicles={formData.recommended_vehicle}
                            setSelectedVehicles={handleVehicleChange}
                        />

                        <TerrainSelect
                            selectedTerrain={formData.terrain}
                            setSelectedTerrain={handleTerrainChange}
                        />

                        <GearSelect
                            selectedGear={formData.required_gear}
                            setSelectedGear={handleGearChange}
                        />
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                            <div>
                                <CommsSelect
                                    value={formData.comms}
                                    onChange={(value) =>
                                        setFormData(prev => ({...prev, comms: value}))
                                    }
                                    readonly={false}
                                />
                            </div>
                            <div>
                                <div>
                                    <label className="block mb-1 text-sm font-bold" htmlFor="Channel">Channel</label>
                                    <input
                                        id="channel"
                                        name="channel"
                                        type="text"
                                        value={formData.channel}
                                        onChange={handleChange}
                                        className="w-full p-2 border border-gray-300 rounded"
                                    />

                                </div>
                            </div>

                        </div>

                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                            <div>
                                <label className="block mb-1 text-sm font-bold" htmlFor="max_rigs">Max Rigs</label>
                                <input
                                    id="max_rigs"
                                    name="max_rigs"
                                    type="number"
                                    value={formData.max_rigs}
                                    onChange={handleChange}
                                    className="w-full p-2 border border-gray-300 rounded"
                                />
                            </div>
                            <div>
                                <label className="block mb-1 text-sm font-bold" htmlFor="technical_rating">
                                    Technical Rating
                                </label>
                                <select
                                    id="technical_rating"
                                    name="technical_rating"
                                    value={formData.technical_rating}
                                    onChange={handleChange}
                                    className="w-full p-2 border border-gray-300 rounded text-center focus:outline-none focus:ring-2 focus:ring-blue-500"
                                >
                                    <option value="">Select a rating</option>
                                    {[...Array(10)].map((_, i) => (
                                        <option key={i + 1} value={i + 1}>
                                            {i + 1}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </div>
                        <div>
                            <label className="block mb-1 text-sm font-bold" htmlFor="meetup_location">Meet
                                Instructions</label>
                            <input
                                id="meetup_location"
                                name="meetup_location"
                                type="text"
                                value={formData.meetup_location}
                                onChange={handleChange}
                                className="w-full p-2 border border-gray-300 rounded"
                            />
                        </div>
                        <div>
                            <label className="block mb-1 text-sm font-bold" htmlFor="gps_location">Meet Address or GPS</label>

                            <div>
                                <AddressToGPSInput
                                    savedValue={formData.meetaddress}
                                    onCoordinatesChange={handleAddressChange}
                                />
                            </div>

                            <div>
                                <GPSCoordinateInput
                                    value={formData.gpscoordinate}
                                    onChange={handleGPSChange}
                                    className="w-full"
                                />
                            </div>

                        </div>

                        <LocationSelect
                            value={formData.location}
                            onChange={(e) =>
                                setFormData(prev => ({...prev, location: e.target.value}))
                            }
                        />
                        { event.revenueevent && (
                            <div>
                                <label htmlFor="specialeventurl" className="block mb-1 text-sm font-medium">
                                        Private Event URL
                                        </label>
                                        <input
                                        id="specialeventurl"
                                        name="specialeventurl"
                                        type="text"
                                        value={formData.specialeventurl}
                                    onChange={handleChange}
                                    className="w-full p-2 border border-gray-300 rounded"
                                />
                            </div>
                        )}
                    </div>
                </div>

                <div className="mt-8 pt-4 border-t border-gray-300">
                    <h2 className="text-xl font-bold mb-4">Co Hosts</h2>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">

                        <div>
                            <label className="block mb-1 text-sm font-medium" htmlFor="chohsot1">Co Host 1</label>
                            <input
                                id="cohost1UserName"
                                name="cohost1UserName"
                                value={formData.cohost1UserName}
                                className="w-full p-2 border border-gray-300 rounded"
                            />
                        </div>
                        <div>
                            <label className="block mb-1 text-sm font-medium" htmlFor="chohost2">Co Host 2</label>
                            <input
                                id="cohost2UserName"
                                name="cohost2UserName"
                                value={formData.cohost2UserName}
                                className="w-full p-2 border border-gray-300 rounded"
                            />
                        </div>
                    </div>
                    <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
                        <div>
                            <UserSearchDropdown
                                onUserSelect={handleCoHost1Select}
                                name="cohost1"
                                placeholder="Enter Co Host 1's handle..."
                                clearSelection={clearCohost1}
                                className="w-full p-2 border border-gray-300 rounded bg-gray-50"
                            />
                        </div>
                        <div>
                            <UserSearchDropdown
                                onUserSelect={handleCoHost2Select}
                                name="cohost2"
                                placeholder="Enter Co Host 2's handle..."
                                clearSelection={clearCohost2}
                                className="w-full p-2 border border-gray-300 rounded bg-gray-50"
                            />
                        </div>
                    </div>
                </div>
                {/* Form buttons at the bottom */}
                <div className="flex flex-wrap justify-between mt-6 gap-2">
                    <button
                        type="button"
                        onClick={handleCancel}
                        className="bg-gray-300 text-gray-700 px-2 py-1.5 sm:px-4 sm:py-2 text-sm sm:text-base rounded hover:bg-gray-400"
                    >
                        Cancel
                    </button>

                    <button
                        type="button"
                        onClick={() => navigate(`/event-questions/${formData.id}`)}
                        className="bg-blue-500 text-white px-2 py-1.5 sm:px-4 sm:py-2 text-sm sm:text-base rounded hover:bg-blue-600 disabled:bg-blue-300 disabled:cursor-not-allowed"
                        disabled={!formData.id}
                    >
                        Add Questions
                    </button>

                    <button
                        type="submit"
                        className="bg-orange-500 text-white px-2 py-1.5 sm:px-4 sm:py-2 text-sm sm:text-base rounded hover:bg-orange-600 disabled:bg-orange-300 disabled:cursor-not-allowed"
                        disabled={isSubmitting}
                    >
                        {isSubmitting ? "Saving..." : "Save Changes"}
                    </button>
                </div>
            </form>
            <div className="max-w-4xl mx-auto mt-8">
                <h2 className="text-xl font-bold mb-4 text-center">Event Attendance</h2>
                <AttendanceTabs goingList={event.goingList} waitingList={event.waitingList} notgoingList={event.notGoingList}
                                currentUserId={event.currentuserid}
                                editable={event.editable}
                                event={event}
                                onAttendeeChange={handleAttendeeChange}/>
            </div>
        </div>
    );
};


export default EditEvent;